<template>
  <div :class="{ 'fixed-box': top }" :style="{ top }">
    <el-card v-if="isShow" class="box-card">
      <i class="el-icon-close" title="Close" @click="hide" />
      <div class="content-wrapper">
        <i class="el-icon-info" />
        <div class="info-text-wrapper">
          <div class="title">{{ t('apexNavigator.title') }}</div>
          <div>{{ t('apexNavigator.content') }}</div>
        </div>
      </div>
      <div class="btn-footer">
        <el-button type="primary" size="mini" @click="handleClick">{{ t('apexNavigator.view') }}</el-button>
        <el-button size="mini" @click="hide">{{ t('apexNavigator.cancel') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
// import { t } from '@/locale'
import locale from '@/mixins/index'
import axios from 'axios'

const getRandom = probability => {
  const newProbability = probability || 100
  const odds = Math.floor(Math.random() * 100)
  if (newProbability === 100) {
    return true
  }
  if (odds < newProbability) {
    return true
  } else {
    return false
  }
}

export default {
  name: 'ApexNavigator',
  mixins: [locale],
  props: {
    env: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: ''
    },
    // 概率   0-100
    probability: {
      type: Number,
      default: 50
    },
    ajaxParams: {
      type: Object,
      default: () => {
        return {
          systemCode: '', // 必填，表示源系统code
          sourceUrl: '', // 必填，表示跳转时源系统地址
          account: '', // 必填，表示跳转时的操作人
          accountCompany: '' // 必填，表示跳转时操作人的所属office
        }
      }
    }
  },
  data() {
    return {
      isShow: false,
      urlObj: {
        test: 'https://navigator-test.apexworkflow.com',
        uat: 'https://navigator.apexuat.com',
        prod: 'https://navigator.apexworkflow.com'
      }
    }
  },
  created() {
    const isShow = getRandom(this.probability)
    if (isShow) {
      this.isShow = true
      // 10秒内浮窗自动关闭
      setTimeout(() => {
        this.isShow = false
      }, 10000)
    }
  },
  methods: {
    handleClick() {
      const url = this.urlObj[this.env]
      if (url) {
        this.isShow = false
        window.open(url)
        this.recordFn()
        this.$emit('confirm')
      } else {
        this.$message.warning('env configuration error, only test、uat、prod')
      }
    },
    recordFn() {
      const apiPrefix = {
        test: 'https://pilotgateway.apexworkflow.com',
        uat: 'https://gateway.apexuat.com',
        prod: 'https://gateway.apexworkflow.com'
      }
      const axiosParams = {
        method: 'post',
        url: apiPrefix[this.env] + '/apex-system-management/api/navigatorAccessLog',
        data: this.ajaxParams
      }
      axios(axiosParams)
    },
    show() {
      this.isShow = true
      this.$emit('show')
    },
    hide() {
      this.isShow = false
      this.$emit('hide')
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-box {
  position: fixed;
  right: 0;
  top: 40px;
  z-index: 999;
}
.box-card {
  width: 350px;
  position: relative;
  .el-icon-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  .content-wrapper {
    display: flex;
    .el-icon-info {
      color: #409eff;
      font-size: 32px;
      margin-right: 10px;
    }
    .info-text-wrapper {
      padding-bottom: 16px;
      padding-top: 2px;
      color: #929292;
      font-size: 14px;
      .title {
        color: #272727;
        font-size: 18px;
        font-weight: bold;
        margin: 2px 0 10px;
      }
    }
  }
  .btn-footer {
    text-align: right;
  }
}
</style>
